import React, { useState, useEffect, Fragment } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  Redirect,
  useLocation,
  useParams,
} from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import Host from "../../Components/Host";
import HelmetComponent from "../../Components/HelmetComponent";
import { useGetUserDataQuery } from "../../services/login";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
function PaymentPolicy() {
  const { userId, userToken, userEmail, userName, isMember, isPaymentMethod, languageCode, countryCode } = useSelector(
    (state) => state.auth
  );
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const [getSearchId, setSearchId] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const { data: userData } = useGetUserDataQuery(
    { userId: userId, userToken: userToken, countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  const myElementRef = React.useRef(null);
  const myElementRefs = React.useRef(null);
  const myContact = React.useRef(null);

  const myPayment = React.useRef(null);
  const myBilling = React.useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.substring(1);
      if (hash === "returns") {
        myElementRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "shipping") {
        myElementRefs.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "contact") {
        myContact.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "billing") {
        myBilling.current.scrollIntoView({ behavior: "smooth" });
      }
      if (hash === "payment") {
        myPayment.current.scrollIntoView({ behavior: "smooth" });
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [window, window.location.hash]);

  return (
    <>
      <HelmetComponent title={"Payment Policy"} />
      <div className="statisc-page">
        <div className="container static-container">
          <div className="row static-row">
            <div className="col-md-10">
              <div
                className="static-container-card"
                style={{
                  textAlign: "left",
                  padding: "20px",
                  background: "#fcfcfc",
                  border: "1px solid #eee",
                  borderRadius: "7px",
                }}
              >
                <h3 style={{ padding: "20px 0px 20px 0px", fontWeight: 300, fontSize: "1.4rem" }}>
                  {t("Payment Policy")}
                </h3>

                <p>
                  At {Host?.domainName}, we take the security of our customers' personal information and payment details
                  seriously. This Payment Policy explains the payment methods we accept, how payments are processed, and
                  how customer payment information is protected.
                </p>

                <h4>Payment Methods</h4>
                <p>We currently accept the following payment methods where available at checkout:</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• Credit cards;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• Debit cards;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• Visa;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• Mastercard;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• American Express;</p>
                <p style={{ marginBottom: "5px", textTransform: "capitalize" }}>• Cash on Delivery, where available.</p>
                <p>
                  Available payment methods may vary depending on the order, delivery location, payment provider, or
                  checkout option selected.
                </p>

                <h4>Payment Processing</h4>
                <p>
                  All online payments made on our website are processed securely through trusted third-party payment
                  gateway providers.
                </p>
                <p>We do not store full credit card or debit card details on our servers.</p>
                <p>
                  Payment information is transmitted securely to our payment processor using secure encryption
                  technologies. The payment processor handles the authorization and processing of card payments in
                  accordance with applicable payment security standards.
                </p>
                <p>
                  The total amount payable, including product price, delivery fee, and any applicable charges, will be
                  shown at checkout before the customer places the order.
                </p>
                <p>
                  Customers will not be charged any additional amount after placing the order unless the customer
                  expressly approves a requested change.
                </p>

                <h4>Payment Security</h4>
                <p>
                  We use reasonable technical and organizational measures to protect customer information and
                  payment-related data, including:
                </p>
                <p style={{ marginBottom: "5px" }}>
                  • SSL encryption to protect data transmitted between our website and customer browsers;
                </p>
                <p style={{ marginBottom: "5px" }}>
                  • secure payment processing through third-party payment gateway providers;
                </p>
                <p style={{ marginBottom: "5px" }}>• restricted access to systems containing customer information;</p>
                <p style={{ marginBottom: "5px" }}>• periodic review and updating of our security practices.</p>
                <p>
                  While we take reasonable steps to protect customer information, no method of transmission over the
                  internet or electronic storage is completely secure. Therefore, we cannot guarantee absolute security.
                </p>

                <h4>Cash on Delivery</h4>
                <p>Where Cash on Delivery is available, customers may pay for the order at the time of delivery.</p>
                <p>
                  Cash on Delivery availability may depend on the delivery location, order value, courier availability,
                  or other operational factors.
                </p>
                <p>
                  If a Cash on Delivery order is refused, cancelled after dispatch, or cannot be delivered due to
                  customer-related reasons, applicable delivery, courier, or handling charges may apply where permitted
                  by applicable law.
                </p>

                <h4>Refunds</h4>
                <p>
                  Approved refunds are handled in accordance with our Returns, Refunds, Cancellation & Warranty Policy.
                </p>
                <p>Refunds for online payments are usually processed to the original payment method where possible.</p>
                <p>
                  For Cash on Delivery orders, approved refunds may be issued through bank transfer, store credit,
                  wallet credit, or another available refund method confirmed by our customer support team.
                </p>
                <p>
                  Refund processing timelines may depend on the bank, card provider, payment service provider, or refund
                  method used.
                </p>

                <h4>Changes to This Payment Policy</h4>
                <p>
                  We may update or modify this Payment Policy from time to time by posting the updated version on our
                  website.
                </p>
                <p>The updated policy will apply from the date it is posted, unless stated otherwise.</p>

                <h4>Contact Us</h4>
                <p>If you have any questions about this Payment Policy or payment security, please contact us:</p>
                <p style={{ lineHeight: 2 }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Host?.address,
                    }}
                  ></div>
                  <MailOutlineIcon style={{ fontSize: "18px" }} /> {Host?.email} <br />
                  <PhoneIcon style={{ fontSize: "18px" }} /> {Host?.phone}
                  <br />
                  <PhoneIcon style={{ fontSize: "1.1rem", color: "#00000059" }} /> +971 4 836 9553
                </p>
                <p>Customer Support: 8:00 AM to 10:00 PM Dubai Time, 7 days a week</p>
                <p>Website: {window.location.hostname}</p>

                <p>&nbsp;</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PaymentPolicy;
